import React, {Component} from 'react';
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Select} from "../../DataEntry";
import {
    getReorderedFormDesign,
} from '../../../containers/AppPage/ControlPanel/Settings/PaneFormDesign.helper';
// import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';
// import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
import { LockTooltip } from '../../Access/common/LockTooltip';
// import { AccessHelper } from '../../Access/helper/helper';

const { Option } = Select;

export function getDefaultFormDesign(formDesigns = [], settings = {}, transactionType = null) {
    if (!transactionType)
        return null;

    let name;
    switch (transactionType) {
        case 'statement':
            name = 'statement_form_design_id';
            break;
        default:
            name = `${transactionType}_form_design_id`;
            break;
    }

    return formDesigns.find(item => (
        item.id === settings[name]
    ));
}

class FormDesignSelect extends Component {
    // hasMultiFormDesignSubscription =
    //     SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_FORM_DESIGN).hasSubscriptionTo();

    static defaultProps = {
        ignoreSubscription: false,
        transactionType: null,
        doNotReorderDefault: false,
    };

    renderOptions = () => {
        const {
            // parent
            transactionType,
            doNotReorderDefault,
            //redux
            settings,
            formDesigns,
        } = this.props;

        const reorderedFormDesigns = getReorderedFormDesign(transactionType, settings, formDesigns);
        const designs = doNotReorderDefault ? formDesigns : reorderedFormDesigns;
        // const defaultFormDesign = getDefaultFormDesign(formDesigns, settings, transactionType);

        return designs.map((item, index) => (
            <Option key={item.id} value={item.id}>
                {
                    (index === 0 && !doNotReorderDefault) ? t`${item.name} (Default)` : item.name
                }
            </Option>),
            // const isLocked = !this.hasMultiFormDesignSubscription && !(item.id === defaultFormDesign?.id);
            // return (
            //     <Option key={item.id} value={item.id} disabled={isLocked}>
            //         {
            //             AccessHelper.getFormLabel((index === 0 && !doNotReorderDefault) ? t`${item.name} (Default)` : item.name, isLocked)
            //         }
            //     </Option>
            // );

        );
    };

    render() {
        const { value, onChange, disabled, readOnly, isInline } = this.props;

        const inlineLockedProps = disabled && isInline ? {
            disabled: true,
            suffixIcon: <LockTooltip placement="right" />,
        } : {};

        return (
            <Select
                value={value}
                onChange={onChange}
                disabled={disabled}
                readOnly={readOnly}
                style={{ width: '100%' }}
                showSearch
                allowClear={false}
                placeholder={t`Select Form Design`}
                optionFilterProp="children"
                popupContainerId="parentElement"
                {...inlineLockedProps}
            >
                {this.renderOptions()}
            </Select>
        );
    }
}

export default connect(state => ({
    formDesigns: state.List.formDesigns,
    settings: state.List.settings,
}), {
})(withI18n()(FormDesignSelect));
